<template>
  <div id="aftercurrent" class="charts" ref="chart" :auto-resize="true"></div>
</template>

<script>
  export default {
    name: "AfterLineChart",
    props: ['data'],
    mounted() {
      this.initCharts()
    },
    watch:{
      data:{
        deep:true,
        handler:function(){
          this.initCharts()
        }
      }
    },
    computed: {
      getShow() {
        return this.$store.getters["echarts/getShow"];
      }
    },
    methods: {
      initCharts() {
        let myChart = this.$echarts.init(this.$refs.chart, 'shine')
        let _this = this
        // let currMax = 1500
        let currMax = Math.max(
          Math.max.apply(Math, _this.data.graphic.map(item => {
            return item.aftercurrent
          }))
        )
        let currMin = Math.min(
          Math.min.apply(Math, _this.data.graphic.map(item => {
            return item.aftercurrent
          }))
        )
        let Maximum = currMax*1.2 < 1500 ? Math.ceil(currMax*1.2) : 1500 // 漏电最大值1500
        let Minimum = currMin > _this.data.aftercurrentAlm ? _this.data.aftercurrentAlm : Math.floor(currMin)
        let Average = Math.floor((Maximum - Minimum) / 5)
        let option = {
          animationDuration: 3000,
          title: {
            text: '剩余电流趋势变化图',
            subtext: '电流阀值：' + _this.data.aftercurrentAlm + 'mA',
            padding: [20, 60],
            textStyle: {
              color: "#303133"
            },
            subtextStyle: {
              lineHeight: 15,
            }

          },
          legend: {
            data: ['剩余电流'],
            padding: [-8, 0, 0, 0]
          },
          grid: {
            top: '20%',
            right: '2%',
            bottom: '6%',
            left: '2%',
          },
          tooltip: {
            trigger: 'axis',
            formatter: function (params) {
              var relVal = '时间：' + params[0].name
              for (var i = 0, l = params.length; i < l; i++) {
                relVal += '<br/>' + params[i].marker + params[i].seriesName +params[i].value + 'mA'
              }
              return relVal
            }
          },
          toolbox: {
            feature: {
              magicType: {
                // show: _this.getShow,
                show: true,
                type: ['bar', 'line']
              },
              saveAsImage: {
                show: _this.getShow
              }
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: _this.data.graphic.map(item => {
              return this.$moment(item.updateTime).format('MM-DD HH:mm:ss')
            })
          },
          yAxis: [
            {
              type: 'value',
              default: 0,
              position: 'left',
              // dataMax: Math.ceil(currMax),
              max: Maximum,
              min: Minimum,
              // interval: Average,  // 平均分为5份
              axisLabel: {
                formatter:'{value} mA'
              },
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              }
            },
            {
              type: 'value',
              default: 0,
              position: 'right',
              // dataMax: Math.ceil(currMax),
              max: Maximum,
              min: Minimum,
              // interval: Average,  // 平均分为5份
              axisLabel: {
                formatter:'{value} mA'
              },
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              }
            }
          ],
          series: [
            {
              type: "line",
              name: '剩余电流',
              data: _this.data.graphic.map(item => {
                return item.aftercurrent
              },),
              itemStyle: { color: '#0098d9' },
              showAllSymbol: false,
              markLine: {
                label: {
                  show: true,
                  position: 'start',
                  color: '#c12e34',
                  formatter: function (params) {
                    return '阀值\n' + params.value
                  }
                },
                data: [{
                  name: '报警阀值',
                  yAxis: _this.data.aftercurrentAlm,
                  type: 'average'
                }],
                symbol: ['arrow', 'round']
              },
            }]
        };
        myChart.setOption(option);
        window.addEventListener('resize', () => {
          myChart.resize();
        })
      }
    }

  }
</script>

<style scoped>
  .charts {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/echarts/AfterLineChart.vue